export enum PostCode {
  postCode,
  pricelist,
  deliveryFee
}